/**
 * Мінімальна форма ресурсу, якої вистачає для перевірки.
 *
 * Навмисно не `IResourceConfig`: перевірку ганяє ще й вартовий, який імпортує
 * ресурси як звичайні об'єкти, і вимагати від них повний контракт означало б
 * тягнути в тест типи, до яких він не має діла.
 */
interface ResourceCreateShape {
    fields?: Record<string, { isEditable?: boolean } | undefined>
    detailConfig?: { modeConfig?: { create?: { template?: unknown } } }
}

/**
 * Чи ресурс узагалі створюється формою.
 *
 * Ядровий `AddButton` з'являється за самим лише правом `create` і веде у
 * стандартну форму створення. Але `create` на беку не завжди означає «заповни
 * картку»: для знімка за період воно означає «сформуй за період», і форми під
 * це немає — усі поля ресурсу лише для читання, бо знімок не редагують.
 *
 * Тоді кнопка «Додати» відкриває картку з самими прочерками й кнопкою
 * «Зберегти», яка нічого не збереже: бек на цьому ж POST чекає період, а форма
 * його не надсилає. Саме цей випадок тут і відрізаємо — **жодного редаговного
 * поля і жодного власного шаблону створення, отже заповнювати нічого**.
 *
 * Ресурси, які створюють не формою, несуть власну кнопку на своїй сторінці
 * (наприклад, «Сформувати»).
 *
 * Обидві невизначеності трактуємо на користь поточної поведінки: немає опису
 * полів — не нам вирішувати, що там неможливо заповнити.
 */
export const CheckResourceCreateFormTask = (resource?: ResourceCreateShape | null): boolean => {
    const fields = resource?.fields

    if (!fields || typeof fields !== 'object') return true

    // Власний шаблон створення малює свої поля — описом полів його не міряти
    if (resource?.detailConfig?.modeConfig?.create?.template) return true

    const names = Object.keys(fields)

    if (names.length === 0) return true

    return names.some((name) => fields[name]?.isEditable !== false)
}
